<template>
  <div class="container-fluid">
    <Breadcrumbs title="Consultar Usuarios" main="Consultar Usuarios" />
    <div class="card border-0 shadow-sm">
      <div class="card-body p-4">
        <div class="row g-3 mb-4">
          <div class="col-lg-4 col-md-6">
            <label class="form-label fw-semibold">Filtrado por nombre</label>
            <input v-model.trim="nombreSeleccionado" type="text" class="form-control"
              placeholder="Introduce el nombre del usuario" @input="filtrarUsuarios" />
          </div>
          <div class="col-lg-4 col-md-6">
            <label class="form-label fw-semibold">Filtrado por Id</label>
            <input v-model.trim="useridSeleccionado" type="text" class="form-control" placeholder="Introduce un Id"
              @input="filtrarUsuarios" />
          </div>
          <div class="col-lg-4 col-md-6">
            <label class="form-label fw-semibold">Filtrado por correo</label>
            <input v-model.trim="correoSeleccionado" type="email" class="form-control"
              placeholder="Introduce un correo electrónico" @input="filtrarUsuarios" />
          </div>
          <div class="col-lg-4 col-md-6">
            <label class="form-label fw-semibold">Filtrado por rol</label>
            <select v-model="rolSeleccionado" class="form-select" @change="filtrarUsuarios">
              <option value="Todos">Todos</option>
              <option v-for="rol in rolesConsultados" :key="rol.id" :value="rol.id">
                {{ rol.name }}
              </option>
            </select>
          </div>
          <div class="col-lg-4 col-md-6">
            <label class="form-label fw-semibold">Filtrado por Estatus</label>
            <select v-model="estatusSeleccionado" class="form-select" @change="filtrarUsuarios">
              <option value="Todos">Todos</option>
              <option value="active">Activo</option>
              <option value="inactive">Inactivo</option>
            </select>
          </div>
          <div v-if="puedeDarDeAlta" class="col-lg-4 col-md-6 d-flex align-items-end">
            <router-link to="/dashboard/alta-usuarios" class="btn btn-primary d-flex align-items-center gap-2">
              <vue-feather type="user-plus" size="18" />
              Dar de alta un usuario
            </router-link>
          </div>
        </div>
        <TablaUsuarios :data-tabla="usuariosFiltrados" @mostrar-modal="usuarioEditando = $event" />
      </div>
    </div>
    <EditarUsuarioModal :usuario="usuarioEditando" :roles="rolesConsultados" @cerrar="usuarioEditando = null"
      @guardado="alGuardarUsuario" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TablaUsuarios from "@/components/TablaUsuarios.vue";
import EditarUsuarioModal from "@/components/EditarUsuarioModal.vue";
import Swal from "sweetalert2";
import { tieneAcceso } from "@/utils/permisos";

export default {
  name: "ConsultarUsuarios",
  components: { TablaUsuarios, EditarUsuarioModal },
  data() {
    return {
      usuarioEditando: null,
      usuariosConsultados: [],
      usuariosFiltrados: [],
      rolesConsultados: [],
      nombreSeleccionado: "",
      correoSeleccionado: "",
      useridSeleccionado: "",
      rolSeleccionado: "Todos",
      estatusSeleccionado: "Todos",
    };
  },
  computed: {
    ...mapState("autenticacion", ["usuarios", "roles", "usuarioActual"]),
    puedeDarDeAlta() {
      return tieneAcceso(this.usuarioActual, "/dashboard/alta-usuarios");
    },
  },
  watch: {
    usuarios: {
      handler(val) {
        this.usuariosConsultados = val || [];
        this.filtrarUsuarios();
      },
      immediate: true,
      deep: true,
    },
    roles: {
      handler(val) {
        this.rolesConsultados = val || [];
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    const correo = this.$route.query.correo || this.$route.params.correo;
    if (correo) this.correoSeleccionado = correo;
    this.cargarDatos();
  },
  methods: {
    ...mapActions("autenticacion", ["consultarUsuarios", "consultarRoles"]),
    async cargarDatos() {
      try {
        await this.consultarUsuarios();
        await this.consultarRoles();
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.msg || "No se pudieron cargar los datos.",
        });
      }
    },
    filtrarUsuarios() {
      let list = [...this.usuariosConsultados];
      if (this.nombreSeleccionado) {
        list = list.filter((u) =>
          (u.name || "").toLowerCase().includes(this.nombreSeleccionado.toLowerCase())
        );
      }
      if (this.useridSeleccionado) {
        list = list.filter((u) =>
          String(u.id ?? "").toLowerCase().includes(this.useridSeleccionado.toLowerCase())
        );
      }
      if (this.correoSeleccionado) {
        list = list.filter((u) =>
          (u.email || "").toLowerCase().includes(this.correoSeleccionado.toLowerCase())
        );
      }
      if (this.rolSeleccionado && this.rolSeleccionado !== "Todos") {
        list = list.filter((u) => String(u.rol) === String(this.rolSeleccionado));
      }
      if (this.estatusSeleccionado && this.estatusSeleccionado !== "Todos") {
        list = list.filter((u) => String(u.status) === this.estatusSeleccionado);
      }
      this.usuariosFiltrados = list;
    },
    async alGuardarUsuario() {
      this.usuarioEditando = null;
      try {
        await this.consultarUsuarios();
      } catch (e) {
        console.error("No se pudo recargar la lista de usuarios:", e);
      }
    },
  },
};
</script>
